<bn-web-ui-card
  class="mb-4"
  heading="Action precedence"
  [isMaxWidth]="false">
  <div class="color-dark-7 mb-4">When multiple rules apply to the same request, we follow an order of precedence to ensure consistent results:</div>

  <div class="d-flex flex-column flex-xxl-row justify-content-between w-100">
    <div class="d-flex flex-column my-3 me-4 flex-fill h-100 action-item">
      <div class="d-flex align-items-center mb-1 action-item--content">
        <div class="d-flex justify-content-center align-items-center action-icon me-2 action-icon--bypass">
          <fa-icon icon="person-to-portal" />
        </div>
        <div class="text-200-semi-bold text-bunny-dark">Bypass</div>
      </div>
      <div class="color-dark-6 mt-1 action-item--content">Requests that match a Bypass skip further evaluation via Shield.</div>
    </div>

    <div class="d-flex flex-column my-3 me-4 flex-fill h-100 action-item">
      <div class="d-flex align-items-center mb-1">
        <div class="d-flex justify-content-center align-items-center action-icon me-2 action-icon--allow">
          <fa-icon icon="circle-check" />
        </div>
        <div class="text-200-semi-bold text-bunny-dark">Allow</div>
      </div>
      <div class="color-dark-6 mt-1">Requests are allowed through other access lists.</div>
    </div>

    <div class="d-flex flex-column my-3 me-4 flex-fill h-100 action-item">
      <div class="d-flex align-items-center mb-1">
        <div class="d-flex justify-content-center align-items-center action-icon me-2 action-icon--block">
          <fa-icon icon="ban" />
        </div>
        <div class="text-200-semi-bold text-bunny-dark">Block</div>
      </div>
      <div class="color-dark-6 mt-1">Requests are denied immediately if they match a block rule.</div>
    </div>

    <div class="d-flex flex-column my-3 me-4 flex-fill h-100 action-item">
      <div class="d-flex align-items-center mb-1">
        <div class="d-flex justify-content-center align-items-center action-icon me-2 action-icon--challenge">
          <fa-icon icon="shield-halved" />
        </div>
        <div class="text-200-semi-bold text-bunny-dark">Challenge</div>
      </div>
      <div class="color-dark-6 mt-1">Suspicious requests are challenged if no higher-priority action applies.</div>
    </div>

    <div class="d-flex flex-column my-3 me-4 flex-fill h-100 action-item">
      <div class="d-flex align-items-center mb-1">
        <div class="d-flex justify-content-center align-items-center action-icon me-2 action-icon--log">
          <fa-icon icon="file-lines" />
        </div>
        <div class="text-200-semi-bold text-bunny-dark">Log</div>
      </div>
      <div class="color-dark-6 mt-1">If no other action matches, the request will be logged.</div>
    </div>
  </div>
</bn-web-ui-card>
